import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../utils/Url";
import DataGrids from "../../utils/Datagrids";
import nopdf from '../../assets/images/imagepreview.jpg';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { format } from 'date-fns';


const containerStyle = {
  width: "100%",
  height: "450px",
};


interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};


export default function PoleInstallation() {
  const [dept, setDept] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [Shows, setShows] = useState<boolean>(false);
  const [IsRep, setRep] = useState<any>("");






  const [vehicles, setVehicles] = useState<any>([]);
  const [activeVehicle, setActiveVehicle] = useState<any>(null);
  const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
  const mapRef: any = React.useRef(null);
  const [currentMap, setCurrentMap] = useState(false);


  
  // Fetch the vehicle data from API
  const MapData = async (Id: any) => {
    setCurrentMap(true);

    const result = await api.post(`PoleInstallation/GetPoleInstallation`, {
      poleInstId:Id,
        zoneId: -1,
        wardId: -1,
        "show": true,
        "exportOption": ""
    });
    const validItems = result?.data?.data[0]["poleInstalChild"];

    console.log("validItems", validItems);
    const arr = validItems.map((item: any, index: any) => ({
      lat: parseFloat(item?.latitute),
      lng: parseFloat(item?.longitute),
      id: index + 1,
      itemName: item?.itemName,
      empName: item?.empName,

      depth: item.depth,
      tracktime: format(item?.apprdate, 'dd-MM-yyyy'),
      poleno: item.poleno,
      zoneName: item?.zoneName,
      wardName: item.wardName ? `${item.wardName} (${item.wardNo})`  : "_ _",

      icon: "https://cdn-icons-png.flaticon.com/512/209/209403.png",
    }));
    setVehicles(arr);
    setCenter(calculateCenter(arr));

    if (arr.length > 0) {
      adjustZoomLevel(arr);
    }
  };

  const calculateCenter = (vehicles: any) => {
    if (vehicles.length === 0) {
      return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
    }

    const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
    const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

    const avgLat =
      latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
    const avgLng =
      longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
      longitudes.length;

    return { lat: avgLat, lng: avgLng }; // Return the center point
  };

  // Adjust the zoom level based on the spread of the vehicles
  const adjustZoomLevel = (vehicles: any) => {
    const bounds = new window.google.maps.LatLngBounds();

    vehicles.forEach((vehicle: any) => {
      bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
    });

    if (mapRef.current) {
      mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
    }
  };

  const handleMarkerMouseOver = (vehicle: any) => {
    setActiveVehicle(vehicle);
  };

  const handleMarkerMouseOut = () => {
    setActiveVehicle(null);
  };




  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    fetchZonesData();
  }, [isLoading]);

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    // console.log(value)
    const collectData = {
      dept_id: value.id,
      dept_name: value.dept_name,
      dept_shortname: value.dept_shortname,
      isActive: event.target.checked,
      user_ID: -1,
      sortOrder: 0,
    };
    api
      .post(`Department/AddUpdateDepartmentmaster`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          fetchZonesData();
        } else {
          toast.error(response.data.mesg);
        }
      });
  };
  const routeChangeEdit = (row: any) => {
    console.log("row " + row);

    let path = `/installation/PoleInstallationEdit`;
    navigate(path, {
      state: row,
    });
  };

  const routeChangeAdd = () => {
    let path = `/installation/PoleInstallationAdd`;
    navigate(path);
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      poleInstId: delete_id,
      // user_ID: 0,
    };
    console.log("collectData " + JSON.stringify(collectData));
    api
      .post(`PoleInstallation/DeletePoleInstallation`, collectData)
      .then((response: any) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchZonesData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };


  const handlePrint = async (Id: any) => {
    const collectData = {
      poleInstId: Id,
      zoneId: -1,
      wardId: -1,
      "show": false,
      "exportOption": ".pdf"
    };
    // console.log("collectData " + JSON.stringify(collectData));
    const response = await api.post(
      `PoleInstallation/GetPoleInstallation`,
      collectData
    );


    if (response) {


      //console.log('Printdata',data)
      setShows(true);
      setRep(response.data);

    }
  };



  const fetchZonesData = async () => {
    try {
      const collectData = {
        poleInstId: -1,
        zoneId: -1,
        wardId: -1,
        "show": true,
        "exportOption": ""
      };
      const response = await api.post(`PoleInstallation/GetPoleInstallation`, collectData);
      const data = response.data.data;
      const deptWithIds = data.map((dept: any, index: any) => ({
        ...dept,
        serialNo: index + 1,
        id: dept.poleInstId,
        wardWithNumber: dept.wardName ? `${dept.wardName} (${dept.wardNo})`  : "_ _"
      }));
      setDept(deptWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit ? ( */}
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => routeChangeEdit(params.row)}
                  />
                  {/* ) : ( */}
                  {/* "" */}
                  {/* )} */}
                  {/* {permissionData?.isDel ? ( */}
                  <DeleteIcon
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handledeleteClick(params.row.id);
                    }}
                  />



                  <VisibilityIcon
                    style={{
                      fontSize: "20px",
                      color: "#65b7c9",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handlePrint(params.row.id);
                    }}
                  />
                  {/* ) : (
                    ""
                  )} */}
                  {/* <Switch
                    checked={Boolean(params.row.isActive)}
                    style={{
                      color: params.row.isActive ? "green" : "#FE0000",
                    }}
                    onChange={(value: any) =>
                      handleSwitchChange(value, params.row)
                    }
                    inputProps={{
                      "aria-label": "Toggle Switch",
                    }}
                  /> */}
                </Stack>,
              ];
            },
          },

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "poleInstdate",
            headerName: t("text.PoleInstallationDate"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "wardWithNumber",  
            headerName: t("text.wardName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },


          {
            field: "map",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Map"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >




                  <LocationOnIcon
                    style={{
                      fontSize: "20px",
                      color: "#65b7c9",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      MapData(params.row.id);
                    }}
                  />
                </Stack>,
              ];
            },
          },

        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.PoleInstallation")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {/* {permissionData?.isAdd == true && ( */}
            <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{ backgroundColor: `var(--header-background)` }}
            >
              {t("text.add")}
            </Button>
            {/* ) } */}

            {/* {permissionData?.isPrint == true ? (
              <Button variant="contained" endIcon={<PrintIcon />} size="large">
                {t("text.print")}
              </Button>
            ) : (
              ""
            )} */}
          </Stack>

          <DataGrids
            isLoading={isLoading}
            rows={dept}
            columns={adjustedColumns}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            initialPageSize={5}
          />


          <Modal open={Shows} onClose={() => setShows(false)}>
            <Box sx={style}>
              {IsRep ? (
                <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
              ) : (
                <img
                  src={nopdf}
                  alt="No Preview"
                  style={{ width: "100%", height: "100%" }}
                />
              )}
            </Box>
          </Modal>




          <Modal open={currentMap} onClose={() => setCurrentMap(false)}>
            <Box sx={style}>
              {currentMap && (
                <Grid item xs={12} sm={12} lg={12}>
                  {/* {isLoading1 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      ) : ( */}
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={70} // Default zoom, will be adjusted by `fitBounds`
                    onLoad={(map: any) => (mapRef.current = map)}
                  >
                    {vehicles.map((vehicle: any) => (
                      <Marker
                        key={vehicle.id}
                        position={{
                          lat: vehicle.lat,
                          lng: vehicle.lng,
                        }}
                        icon={{
                          url: vehicle.icon,
                          scaledSize: new window.google.maps.Size(
                            50,
                            50
                          ),
                          origin: new window.google.maps.Point(0, 0),
                          anchor: new window.google.maps.Point(25, 25),
                        }}
                        onMouseOver={() =>
                          handleMarkerMouseOver(vehicle)
                        } // Show vehicle number on hover
                        onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
                      >
                        {activeVehicle &&
                          activeVehicle.id === vehicle.id && (
                            <InfoWindow>
                              <div>
                                <div>
                                          <strong>Zone Name: </strong>
                                          {vehicle.zoneName}
                                        </div>

                                        <div>
                                          <strong>Ward Name: </strong>
                                          {vehicle.wardName}
                                        </div>

                                <div>
                                  <strong>Depth: </strong>
                                  {vehicle.depth}
                                </div>

                                <div>
                                  <strong>Pole No: </strong>
                                  {vehicle.poleno}
                                </div>

                                <div>
                                  <strong>Date : </strong>
                                  {vehicle.tracktime}
                                </div>
                              </div>
                            </InfoWindow>
                          )}
                      </Marker>
                    ))}
                  </GoogleMap>
                  {/* )} */}
                </Grid>
              )}
            </Box>
          </Modal>
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
